import { createGate } from 'effector-react';
import { createEvent } from 'effector';

export const InvestProGate = createGate();

export const toggleShowProjectsEv = createEvent();

export const toggleShowRegionsEv = createEvent();

export const changeRegionsLayerEv = createEvent();

export const changeProjectModalEv = createEvent();
export const resetProjectModalEv = createEvent();

export const changeActiveModalEv = createEvent();

export const separateDotsEv = createEvent();

export const changeHexPropertyEv = createEvent();

export const toggleShowHeatmapEv = createEvent();

export const changePopupDataEv = createEvent();
export const resetPopupDataEv = createEvent();
